module.exports = __webpack_public_path__ + "img/logo.a060bca6.png";